import * as React from 'react';
import { defaults } from 'react-chartjs-2';

export const useThemeObserver = () => {
  const [display, setDisplay] = React.useState<any>(true);
  const fontColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--intermix-text-color')
    .trim();
  defaults.global.defaultFontColor = fontColor;
  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      const fontColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--intermix-text-color')
        .trim();
      setDisplay(false);
      defaults.global.defaultFontColor = fontColor;
      setDisplay(true);
    });
    const config = {
      attributes: true,
    };
    observer.observe(document.documentElement, config);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return { display };
};
